<template>
<div
    style="margin-left: 15px;"
>
    <v-chip
        dense
        :color="chip_bkg_color"
        style="color: white;"
        label
    >
        {{text}}
    </v-chip>
</div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: function() { return 'new'; }
        },
    },

    computed: {
        chip_bkg_color() {
            let type = this.type.toLocaleLowerCase().trim();

            if ( type == 'rc-staff' ) return 'green';
            return 'blue';
        },

        text() {
            let type = this.type.toLocaleLowerCase().trim();

            if ( type == 'rc-staff' ) return 'RedChirp Staff Only';
            return 'New';
        },
    },
}
</script>

<style lang="scss" scoped>
</style>